// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"9c6f4ba1","2151":"2ca3836f","3325":"37ac79a4","5782":"530b5afe"}[chunkId] + ".chunk.css";
};